module.exports = __webpack_public_path__ + "static/media/image12.4277e0d5.jpg";